<script setup lang="ts">
import {PageHeading} from "@/Components/Global";
import {useMainStore} from "@/Stores/store";

const $store = useMainStore();
</script>
<template>
    <div class="m-container">
        <PageHeading title="Dashboard" class="mb-4 mt-2" />
        <div>
            <p>
                Welcome,
                <span class="font-bold">{{ $store.user.first_name }} {{ $store.user.last_name }}.</span>
            </p>
            <p>Your role is {{ $store.user.roles?.length && $store.user.roles[0].name }}.</p>
        </div>
    </div>
</template>
<style scoped></style>
